module.exports = "<h4 class=\"weui_media_title\"><slot></slot></h4>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-title.vue
 ** module id = 167
 ** module chunks = 0
 **/